import { useState } from 'react';
import styled from 'styled-components';
import { ClickAwayListener, Box, Typography } from '@mui/material';

import { colors } from '../../theme';

// icons
import { ReactComponent as ArrowIcon } from '../../assets/icons/menu-arrow-icon.svg';

export interface OptionProps {
    isLast: boolean;
    selectedItem: boolean;
    optionsColor?: string;
    optionsBackgroundColor?: string;
    optionsBackgroundHoverColor?: string;
    isHover?: boolean;
}

export interface ContainerProps {
    single?: boolean;
    isHover?: boolean;
}

const MenuDropdown = (props: any) => {
    const { data, icon, placeholder, value, name, field, dataItemKey, onChange, singleOption=false, isHover=false, dropdownColor, optionsColor, dropdownBackgroundColor, optionsBackgroundColor, dropdownBackgroundHoverColor, optionsBackgroundHoverColor, borderRadius='5px' } = props;

    const [optionOpen, setOptionOpen] = useState(false);

    const handleOpen = () => {
        setOptionOpen((state) => !state);
    };

    const handleClickAway = () => {
        setOptionOpen(false);
    };

    const handleItemClick = (item: any) => {
        onChange({
            target: {
                name: dataItemKey,
                value: item,
            },
        });
        setOptionOpen((state) => !state);
    };
    
    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <DropdownContainer {...props} onMouseOver={isHover ? handleOpen : null} onMouseOut={isHover ? handleClickAway : null} onClick={handleOpen}>
                {icon}
                <Typography>{value ? value[name] : placeholder}</Typography>
                <ArrowIcon style={{ width: '17px', marginRight: '0px' }} />
                {optionOpen && (
                    <OptionContainer {...props} single={singleOption}>
                        {data &&
                            data.map((item: any, index: any) => {
                                let selectedItem = false;
                                if (value && value.length > 0) {
                                    if (value.indexOf(item) !== -1) selectedItem = true;
                                }
                                return (
                                    <Option
                                        {...props}
                                        key={index}
                                        isLast={index === data.length - 1}
                                        selectedItem={selectedItem}
                                        onClick={() => {
                                            handleItemClick(item);
                                            setOptionOpen((state) => !state);
                                        }}
                                    >
                                        {item[name]}
                                    </Option>
                                );
                            })}
                    </OptionContainer>
                )}
            </DropdownContainer>
        </ClickAwayListener>
    );
};

export default MenuDropdown;

const DropdownContainer = styled.div<{ dropdownBackgroundColor?: string, dropdownBackgroundHoverColor?: string, borderRadius?: string }>`
    display: flex;
    align-items: center;
    position: relative;
    padding: 5px 8px;
    border-radius: ${({ borderRadius }) => borderRadius || '5px'};
    justify-content: center;
    
    background-color: ${({ dropdownBackgroundColor }) => dropdownBackgroundColor || 'inherit'};

    p {
        color: ${colors.white};
        margin-right: 5px;
    }

    svg {
        width: 22px;
        height: auto;
        path {
            fill: ${colors.white};
        }
    }

    &:hover {
        cursor: pointer;
        background-color: ${({ dropdownBackgroundHoverColor }) => dropdownBackgroundHoverColor || 'rgba(22, 47, 66, 0.5)'};
    }
`;

const OptionContainer = styled.div<ContainerProps>`
    position: absolute;
    top: ${(props) => props.isHover ? '100%' : '130%'};
    left: 0;
    background-color: ${colors.navy.main};
    max-height: 230px;
    overflow-y: ${(props) => props.single ? 'hidden' : 'scroll'};
    width: 100%;
    overflow-x: hidden;
    filter: drop-shadow(8px 16px 24px rgba(69, 79, 89, 0.04));
    z-index: 90;
`;

const Option = styled.div<OptionProps>`
    border-bottom: ${(props) => !props.isLast && `1px solid ${colors.white}`};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 5px;
    text-align: center;
    background-color: ${(props) => props.optionsBackgroundColor || 'inherit'};
    color: ${(props) => props.optionsColor || colors.white};
    border: ${(props) => props.isHover ? `1px solid ${colors.blue.main}` : 'inherit'};
    
    &:hover {
        cursor: pointer;
        background-color: ${(props) => props.optionsBackgroundHoverColor || colors.blue.hover};
    }
    &:last-of-type {
        border-top: none;
    }
`;
